<template>
    <q-modal v-model="showEditDialog" no-backdrop-dismiss>
      <q-toolbar color="primary" style="justify-content:space-between;">
                <q-toolbar-title shrink>
                    Корректировка наличия материала
                </q-toolbar-title>
                
        </q-toolbar>       
        
        <div class="param-container q-title text-primary">

            <div class='q-ma-sm'>
                <span class='text-primary q-body-1'>Тип материала:</span> {{materialType}}
            </div>
            <div  class='q-ma-sm'>
                <span class='text-primary q-body-1'>Номенклатура:</span> {{materialName}}
            </div>

            <div class="row no-wrap q-mt-md full-width input-param q-pa-xs">
                <div class="col-4 q-pa-sm">
                    <q-input 
                        name="materialCount"
                        v-model="materialCount" 
                        float-label="Количество по базе, м.п." 
                        type='number'
                        readonly=""
                        align='center'
                    />   

                </div>
                <div class="col-4  q-pa-sm">           
                    <q-input 
                        name="correctCount"
                        v-model="correctCount" 
                        float-label="Корректировка количества" 
                        error
                        align='center'
                        type='number'
                        :step="1"
                    />   
                </div>
                <div class="col-4  q-pa-sm">
                    <q-input 
                        name="correctedCount"
                        v-model="correctedCount" 
                        float-label="с учетом корректировки" 
                        align='center'
                        type='number'
                        readonly=""
                    />   

                </div>
            </div>
          

        </div>
        <div class='button-container'>
            <q-btn
                color="negative"
                @click="closeEditDialog"
                label="Отмена"
                outline
            />
            <q-btn
                color="positive"
                :loading='isLoading'
                @click="saveEditDialog"
                style="margin-left:20px; width:150px;"
            >
                <span v-if='materialId==-1'>Добавить</span>
                <span v-if='materialId != -1'>Сохранить</span>
            </q-btn>

        </div>
    </q-modal>

</template>

<script>

/* eslint-disable */
export default {
    name : 'correctDialog',
    
    data () {
            return {
                materialId : -1, // идентификатор ИД материала. если -1 - то добавляем новый материал
                materialName : null,
                materialType : null,
                materialCount : null,
                correctCount : 0,
                showEditDialog : false, // флаг видимости диалога
            //Параметры материала                
                isLoading : false,
            }
    },

    created() {
        eventBus.$on("showCorrectDialog", (materialId)=> {
            this.materialId = materialId;
            if (materialId > -1) { //значит редактируем и надо бы заполнить поля

                if (this.$store.getters.getNomenklaturaById(materialId) != undefined) {                    
                    let q = this.$store.getters.getNomenklaturaById(materialId);
                    this.materialName = q.name;
                    this.materialCount = q.count;
                    this.materialType = (this.$store.getters.getMaterialById(q.type_id) != undefined) ? this.$store.getters.getMaterialById(q.type_id).name : '';
                }

            }
            this.showEditDialog = true; // показываем диалоговое окно
        });
    },

    beforeDestroy() {
        eventBus.$off('showEditMaterialDialog');
    },

    computed: {
        correctedCount :{
            get : function() {return Math.round((this.materialCount*1+this.correctCount*1)*100)/100;},
            set : function() {},
        },


    },

    methods : {
        
        clearFormData() {
            this.materialName = '';
            this.correctCount = 0;
        },

        closeEditDialog() {
            this.showEditDialog = false;
            this.clearFormData();
        },

        saveEditDialog() {


            this.isLoading = true;

            var data = {                
                id : this.materialId,
                correction : this.correctCount
            };

            this.$store.dispatch('correctMaterial', data)
            .then(()=>{
                this.isLoading = false;
                this.showEditDialog = false;
                this.clearFormData();
                this.$admns.showNotify('Количество скорректировано','success','Сообщение системы');

            });
            
        },
    }

}


</script>

<style lang="scss" scoped>
    .param-container {
        padding:30px;
        width:600px;
        min-height:200px;
    }
    .button-container {
        padding:30px;
        text-align: right;
    }
    .input-param {
        border : 1px dotted gray;
        border-radius: 5px;
    }
</style>

